class FormatFunction {
  static phoneRegx = () =>
    /(^02.{0}|^01.{1}|050.{1}|[0-9]{3})([0-9]+)([0-9]{4})/;

  static businessRegx = () => /([0-9]{3})([0-9]{2})([0-9]{5})/;

  /**
   * 전화번호 문자열 변환 함수
   * 01xxxxxxxxx -> 01x-xxxx-xxxx
   * @param value
   */
  static regPhoneNumber = (value: string | undefined) => {
    return value ? value.replace(this.phoneRegx(), `$1-$2-$3`) : "-";
  };

  /**
   * 사업자등록번호 변환 함수
   * 22xxxxxxxx -> 22x-22-22222
   * @param value
   * @returns
   */
  static regBusinessNumber = (value: string | undefined) =>
    value ? value.replace(this.businessRegx(), "$1-$2-$3") : "-";

  /**
   * 숫자형식 처리 포맷
   * @param value
   * @param options
   * @returns
   */
  static numFormat = (
    value: number | bigint | undefined,
    options: Intl.NumberFormatOptions = {}
  ) =>
    value
      ? new Intl.NumberFormat("ko-KR", { ...options }).format(value)
      : undefined;
}

export default FormatFunction;
